
// Utilitário para converter string monetária mascarada para número
function parseCurrencyToNumber(valor: string | number): number {
  if (typeof valor === 'number') return valor;
  if (!valor) return 0;
  let cleaned = valor.replace(/[^\d,]/g, '');
  const lastComma = cleaned.lastIndexOf(',');
  if (lastComma !== -1) {
    cleaned =
      cleaned.slice(0, lastComma).replace(/,/g, '') +
      '.' +
      cleaned.slice(lastComma + 1);
  }
  return Number(cleaned) || 0;
}

export function calculateItemTotal(item: any) {
  const quantity = Number(item?.quantity || 0);
  const unitValueRaw = item?.isLabor ? (item?.idLaborBudget?.wage ?? item?.unitValue ?? 0) : (item?.unitValue ?? 0);
  const unitValue = parseCurrencyToNumber(unitValueRaw);
  return quantity * unitValue;
}

export function calculateStepTotal(step: any) {
  if (!step?.itens || !Array.isArray(step.itens)) return 0;
  return step.itens.reduce((acc: number, it: any) => acc + calculateItemTotal(it), 0);
}

export function calculateBudgetTotals(steps: any[] = [], percentageExtraCost = 0, alicotaValue = 0, percentageProfitMargin = 0) {
  const baseTotal = (steps || []).reduce((acc: number, s: any) => acc + calculateStepTotal(s), 0);
  const extrasPercent = (Number(percentageExtraCost || 0) + Number(alicotaValue || 0) + Number(percentageProfitMargin || 0)) / 100;
  const total = baseTotal + baseTotal * extrasPercent;
  return { baseTotal, total };
}
